import OmissionNoticeViewModel from "viewModels/notice/omission/omissionNoticeViewModel";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";

const OmissionNoticeWidgetIdentifier = "edaz-omission";

registerWidget({
  component: makeWidgetFor(OmissionNoticeWidgetIdentifier, [OmissionNoticeViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: OmissionNoticeWidgetIdentifier,
  },
});
